// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed3ac3d2","453":"097b05b5","732":"86425634","977":"361f566f"}[chunkId] + ".chunk.js";
};